import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "./shared";

export function useArticleCodeCheck(code, orderId, online, enabled) {
  const value = code.trim();
  const [state, setState] = useState({ value: "", status: "idle", message: "" });
  useEffect(() => {
    if (!enabled || !online || !value) return;
    const controller = new AbortController();
    setState({ value, status: "checking", message: "" });
    const timer = setTimeout(async () => {
      try {
        const { data } = await axios.get(`${API}/artikelcode-controle`, { params: { productcode: value, bestelling_id: orderId || undefined }, signal: controller.signal, timeout: 10000 });
        if (!controller.signal.aborted) setState({ value, status: data.bestaat ? "duplicate" : "available", message: data.melding });
      } catch (error) {
        if (!controller.signal.aborted) setState({ value, status: "error", message: "Artikelcode nu niet te controleren. Bij het opslaan wordt opnieuw gecontroleerd." });
      }
    }, 350);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [value, orderId, online, enabled]);
  if (!enabled || !value) return { status: "idle", message: "" };
  if (!online) return { status: "offline", message: "Artikelcode wordt bij het versturen gecontroleerd." };
  return state.value === value ? state : { status: "checking", message: "" };
}